import { resetOffers } from '../store/redux/slices/offersSlice';
import { resetProductFactory } from '../store/redux/slices/productFactorySlice';
import { resetSelection } from '../store/redux/slices/selectionSlice';
import store from '../store/redux/store';

interface ResetState {
  reset: () => void;
}

const useSalesConversationResetState = (): ResetState => {
  const reset = () => {
    store.dispatch(resetOffers());
    store.dispatch(resetSelection());
    store.dispatch(resetProductFactory());
  };

  return { reset };
};

export default useSalesConversationResetState;
